var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.535645,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#A1A5C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4352 16.2755C14.4352 17.1097 14.4352 17.5268 14.5991 17.7313C14.7415 17.9089 14.9564 18.0081 15.1802 17.9995C15.4378 17.9896 15.741 17.7125 16.3476 17.1583L19.9323 13.8828C20.2665 13.5775 20.4335 13.4248 20.4951 13.2446C20.5492 13.0863 20.5492 12.9137 20.4951 12.7554C20.4335 12.5752 20.2665 12.4225 19.9323 12.1172L16.3476 8.84174C15.741 8.28753 15.4378 8.01043 15.1802 8.00052C14.9564 7.99191 14.7415 8.0911 14.5991 8.26875C14.4352 8.47324 14.4352 8.89034 14.4352 9.72453V16.2755Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53564 16.2755C6.53564 17.1097 6.53564 17.5268 6.69957 17.7313C6.84198 17.9089 7.05686 18.0081 7.28064 17.9995C7.53823 17.9896 7.8415 17.7125 8.44804 17.1583L12.0328 13.8828C12.3669 13.5775 12.534 13.4248 12.5956 13.2446C12.6496 13.0863 12.6496 12.9137 12.5956 12.7554C12.534 12.5752 12.3669 12.4225 12.0328 12.1172L8.44804 8.84174C7.8415 8.28753 7.53823 8.01043 7.28064 8.00052C7.05686 7.99191 6.84198 8.0911 6.69957 8.26875C6.53564 8.47324 6.53564 8.89034 6.53564 9.72453V16.2755Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueed);
export default __webpack_public_path__ + "static/media/queed.e06f8838.svg";
export { ForwardRef as ReactComponent };